import api from './axiosConfig';

export const getDashboardAnalyticsApi = () => {
  return api.get('/v1/dashboard/analytics');
};

export const exportDashboardReportApi = () => {
  return api.get('/v1/dashboard/export', { responseType: 'blob' });
};

export const saveTargetSnapshotApi = () => {
  return api.post('/v1/dashboard/save-snapshot');
};

export const getNotificationsApi = () => {
  return api.get('/v1/dashboard/notifications');
};

export const markNotificationsReadApi = (notificationIds) => {
  return api.put('/v1/dashboard/notifications/read', { notificationIds });
};
